/*! mfac-pdp-kinks.js — PDP display kinks (write theme). Strip .00 prices; sync radio checked attrs. */
(function () {
  'use strict';
  var PRICE_SEL =
    '.element-text--price, [data-product-price], .product__price, .product-block--price, .grid-product__price';
  var RE = /\.00(?!\d)/g;
  var busy = false;

  function stripTextNode(node) {
    if (!node || node.nodeType !== 3) return;
    var t = node.nodeValue;
    if (!t || t.indexOf('.00') === -1) return;
    if (!/[\d$£€]/.test(t)) return;
    var next = t.replace(RE, '');
    if (next !== t) node.nodeValue = next;
  }

  function walk(root) {
    if (busy || !root) return;
    busy = true;
    try {
      var list = root.querySelectorAll ? root.querySelectorAll(PRICE_SEL) : [];
      for (var i = 0; i < list.length; i++) {
        var el = list[i];
        var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
        var n;
        while ((n = walker.nextNode())) stripTextNode(n);
      }
    } finally {
      busy = false;
    }
  }

  function syncChecked(wrap) {
    if (!wrap) return;
    var radios = wrap.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      var inp = radios[i];
      inp.removeAttribute('checked');
      if (inp.checked) inp.setAttribute('checked', 'checked');
    }
  }

  function onReady() {
    walk(document);
    document.addEventListener(
      'change',
      function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        var wrap = t.closest('.variant-input-wrap');
        if (wrap) syncChecked(wrap);
        setTimeout(function () {
          walk(document);
        }, 40);
      },
      true
    );
    if (typeof MutationObserver !== 'undefined') {
      var mo = new MutationObserver(function () {
        walk(document);
      });
      mo.observe(document.documentElement, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
